import * as React from 'react';
import autobind from 'autobind-decorator';

import { AgentListDataService } from '../list/agent-list.data';
import { AgentEditorView } from './agent-editor.view';

interface AgentEditorControllerProps {
	mode: ControlMode;
	label?: string;
	value: number | null;
	distinctFrom?: number;
	onChanged: (value: AgentSummary) => void;
	setBusy(isBusy: boolean);
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class AgentEditorController extends React.Component<AgentEditorControllerProps, any> {
	protected agentDataService: AgentListDataService;

	constructor(props) {
		super(props);
		this.agentDataService = AgentListDataService.make();
	}

	@autobind
	protected agentQuery(q?: string): Promise<QueryResult<AgentSummary>> {
		return new Promise<QueryResult<AgentSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.agentDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.distinctFrom != null) {
				this.agentDataService.addFilter('id', 'ne', this.props.distinctFrom);
			}

			this.agentDataService.addSorting('name', 'asc', true);
			this.agentDataService.searchKeywords = q;
			this.agentDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.agentDataService.count
					});
				});
		});
	}

	render() {
		return (
			<AgentEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				agentsRequest={{ query: this.agentQuery, dataSet: this.agentDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				label={this.props.label}
				mode={this.props.mode}
				required={this.props.required}
				
			>
				{this.props.children}
			</AgentEditorView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/parts/agent-editor.controller.tsx